import { ref } from 'vue';

export const isAtcivatedWatchMangeOraganisation = ref(false);
export const ismanagedSaveOrganisation = ref(false);
